// Error boundary for the Dashboards route.
// Modern.js renders this component when the page throws during render.
// The error + reset props are injected by the framework.
import { useAddI18nLocales, useTranslation } from './i18n';

export const DashboardsErrorBoundary = ({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) => {
  useAddI18nLocales();
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-cds-py-8 tw-cds-gap-5">
      <p className="tw-cds-font-body-02 tw-cds-text-secondary">
        {error.message}
      </p>
      <button
        type="button"
        className="tw-cds-font-label-01 tw-cds-text-brand"
        onClick={reset}
      >
        {t('ERROR_RETRY')}
      </button>
    </div>
  );
};
